<div class="mat-elevation-z2 mb-1 bg-white p-2 pt-3">
  @if (showFilter) {
    <div class="d-flex justify-content-between">
      <mat-form-field
        appearance="outline"
        class="col-12 col-md-6 col-lg-4"
        style="padding-bottom: 0"
      >
        <mat-label>Pesquisar</mat-label>
        <input
          type="search"
          #pesquisa
          matInput
          (input)="applyFilter($event.target)"
          placeholder="Digite aqui sua busca"
        />
      </mat-form-field>
      <!-- Botão de importar do gp-digital -->
      @if (showAbsenceImport) {
        <div class="col-4 text-end">
          <!-- <a mat-stroked-button class="text-success me-2">
          <i class="fas fa-file-excel me-2"></i>Exportar base
        </a> -->
          <button mat-stroked-button color="primary" (click)="importClicked()">
            <i class="fas fa-plus me-2"></i>Importar
          </button>
        </div>
      }
      <!-- Botão de adicionar do gp-digital -->
      @if (showAddButton && accessGroupId == 0) {
        <div class="col-3 col-md-6 col-lg-2 text-end">
          <button
            type="button"
            mat-stroked-button
            color="primary"
            (click)="addClick()"
          >
            <i class="far fa-plus me-0 me-lg-2"></i>
            <span class="d-none d-lg-inline-block">Adicionar</span>
          </button>
        </div>
      }
      <!-- Botão de adicionar liberações de softwares no workspace -->
      @if (showAddButton && accessGroupId > 0) {
        <div class="col-3 col-md-6 col-lg-2 text-end">
          <button
            type="button"
            mat-stroked-button
            color="primary"
            (click)="addClickSoftware()"
          >
            <i class="far fa-plus me-0 me-lg-2"></i>
            <span class="d-none d-lg-inline-block">Adicionar</span>
          </button>
        </div>
      }
    </div>
  }

  <div #mainContent class="w-100" style="overflow: auto">
    <ng-content></ng-content>
  </div>
  @if (showPaginator) {
    <mat-paginator
      #paginator
      [pageSize]="50"
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
      (page)="onPage()"
      class="mt-2 mt-md-0"
    >
    </mat-paginator>
  }
</div>
